"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _label = _interopRequireDefault(require("./label"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _checkboxModule = _interopRequireDefault(require("./checkbox.module.scss"));

var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));

var _field = require("./field");

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Styleguide checkbox
// ===================


class Checkbox extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      checked: this.props.checked
    });
    (0, _defineProperty2.default)(this, "onClickOrChange", () => {
      if (this.props.onChange) {
        this.props.onChange(!this.state.checked);
      } else {
        this.setState(state => ({
          checked: !state.checked
        }));
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.checked !== undefined && prevProps.checked !== this.props.checked) {
      this.setState((_state, props) => ({
        checked: props.checked
      }));
    }
  }

  render() {
    const id = this.props.id || (0, _field.makeIdString)();
    const inputAttributes = {
      type: 'checkbox',
      className: (0, _classnames.default)(_checkboxModule.default.field, {
        [_checkboxModule.default.fieldSmall]: this.props.size === _fieldsize.default.SMALL
      }, {
        [_checkboxModule.default.fieldInvalid]: this.props.errorMessage
      }, this.props.classNames.field),
      id,
      'data-test-id': this.props.dataTestId,
      disabled: this.props.disabled,
      'aria-label': this.props.ariaLabel,
      onBlur: this.props.onBlur,
      name: this.props.name,
      ref: this.props.innerRef
    };

    if (this.props.onChange) {
      inputAttributes.checked = this.props.checked;
      inputAttributes.onChange = this.onClickOrChange;
    } else {
      inputAttributes.defaultChecked = this.props.checked;
      inputAttributes.onClick = this.onClickOrChange;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_checkboxModule.default.Checkbox, this.props.classNames.wrapper, {
        [_checkboxModule.default.disabled]: this.props.disabled
      })
    }, /*#__PURE__*/_react.default.createElement("input", inputAttributes), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_label.default, {
      size: this.props.size,
      className: (0, _classnames.default)(this.props.classNames.label, {
        [_textfieldModule.default.errorLabel]: this.props.errorMessage
      }),
      for: id
    }, this.props.label), this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
      size: this.props.size,
      message: this.props.errorMessage,
      className: this.props.classNames.errorMessage
    })));
  }

}

exports.default = Checkbox;
Checkbox.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _field.fieldPropTypes), _fieldsize.fieldSizePropTypes), {}, {
  checked: _propTypes.default.bool
});
Checkbox.defaultProps = _objectSpread(_objectSpread({
  checked: false
}, _fieldsize.fieldSizeDefaultProps), {}, {
  classNames: {}
});